<template>
    <div id="Equip_info_manage">
        <el-scrollbar :class="isCollapse?'menu_hide rightSide':'rightSide'">
            <el-main>
                <nav-bar></nav-bar>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :label="$t('MeterBasicInformationManagement')" v-if="judge('Equipment_ViewElectricTab')" name="first">
                        <el-form ref="formselect" :model="formselect" label-width="60px" class="queryform_div">
                            <areaSelect :hasDeviceName="true" :level="level" :deviceType="deviceType" :formArea="formArea"
                                        :enablesys="'1'"
                                        @areaList="getAreaList"></areaSelect>
                            <el-form-item>
                                <el-button @click="selectByKeyword()" type="primary">{{ $t('Query') }}</el-button>
                                <el-button @click="reset('tab1')">{{ $t('Reset') }}</el-button>
                            </el-form-item>
                        </el-form>
                        <template>
                            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addNew"
                                       v-if="judge('Equipment_CreateElectric')"
                                       style="margin-bottom:10px;">{{ $t('AddNewDevice') }}
                            </el-button>
                            <template v-if="judge('Equipment_DeleteElectric')">
                                <el-popconfirm placement="top"
                                               :confirmButtonText="$t('Delete')"
                                               :cancelButtonText="$t('Cancel')"
                                               icon="el-icon-info"
                                               iconColor="red"
                                               @onConfirm="batchDeleteEle"
                                               :title="$t('DeleteInformation')">>
                                    <el-button type="danger" slot="reference" style=" margin-left: 10px;">{{ $t('BatchDelete') }}
                                    </el-button>
                                </el-popconfirm>
                            </template>
                            <el-table ref="multipleTable"
                                      :data="tableData1"
                                      v-loading="loading"
                                      tooltip-effect="dark"
                                      @selection-change="handleSelectionChange"
                                      border
                                      stripe
                                      style="width:100%;min-height:200px;">
                                <el-table-column fixed="left"
                                                 type="selection"
                                                 width="50">
                                </el-table-column>
                                <el-table-column prop="index"
                                                 :label="$t('SN')"
                                                 width="50">
                                </el-table-column>
                                <el-table-column prop="countryName"
                                                 :label="$t('Country')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="cityName"
                                                 :label="$t('City')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="factoryName"
                                                 :label="$t('Campus')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="buildingName"
                                                 :label="$t('Building')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="laboratoryName"
                                                 :label="$t('Lab')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="deviceName"
                                                 :label="$t('DeviceName')"
                                                 width="150">
                                </el-table-column>
                                <el-table-column prop="gatewayName"
                                                 :label="$t('Gateway')"
                                                 width="150">
                                </el-table-column>
                                <el-table-column prop="functionCode"
                                                 :label="$t('Function')"
                                                 width="200">
                                </el-table-column>
                                <!--                                <el-table-column prop="departmentCode"-->
                                <!--                                                 label="部门"-->
                                <!--                                                 width="150">-->
                                <!--                                </el-table-column>-->
                                <el-table-column prop="cabinetCode"
                                                 :label="$t('CabinetNumber')"
                                                 width="150">
                                </el-table-column>
                                <el-table-column prop="brand"
                                                 :label="$t('Brand')"
                                                 width="150">
                                </el-table-column>
                                <el-table-column prop="type"
                                                 :label="$t('Model')"
                                                 width="100">
                                </el-table-column>

                                <el-table-column prop="enableInSys"
                                                 :label="$t('Connectedtosystem')"
                                                 width="100">
                                    <template slot-scope="scope">
                                        <label>{{scope.row.enableInSys?$t('yes'): $t('No')}}</label>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="ratedVoltage"
                                                 :label="$t('Ratedvoltage')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="ratedCurrent"
                                                 :label="$t('Ratedcurrent')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="maxPower"
                                                 :label="$t('MaxInstantaneousPower')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="accuracy"
                                                 :label="$t('Accuracy')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="magnification"
                                                 :label="$t('Magnification')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="location"
                                                 :label="$t('Position')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="power"
                                                 :label="$t('SuperiorPowerSupply')"
                                                 width="100">
                                </el-table-column>

                                <el-table-column prop="baudRate"
                                                 :label="$t('BaudRate')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="startBit"
                                                 :label="$t('StartingBit')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="stopBit"
                                                 :label="$t('TerminationBit')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="verifyBit"
                                                 :label="$t('CheckDigit')"
                                                 width="100">
                                </el-table-column>
                                <!--                                <el-table-column prop="remark"-->
                                <!--                                                 label="备注"-->
                                <!--                                                 width="100">-->
                                <!--                                </el-table-column>-->
                                <el-table-column fixed="right"
                                                 :label="$t('Action')"
                                                 width="180">
                                    <template slot-scope="scope">
                                        <el-button v-if="judge('Equipment_UpdateElectric')" @click="editInfo(scope.row)"
                                                   type="primary" size="small">{{ $t('Edit') }}
                                        </el-button>
                                        <template v-if="judge('Equipment_DeleteElectric')">
                                            <el-popconfirm placement="top"
                                                           :confirmButtonText="$t('Delete')"
                                                           :cancelButtonText="$t('Cancel')"
                                                           icon="el-icon-info"
                                                           iconColor="red"
                                                           @onConfirm="deleteEleById(scope.row.deviceRegionId)"
                                                           :title="$t('DeleteConfirm')">
                                                <el-button size="mini" type="danger" slot="reference"
                                                           style=" margin-left: 10px;">{{ $t('Delete') }}
                                                </el-button>
                                            </el-popconfirm>
                                        </template>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                    background
                                    @current-change="handleCurrentChange"
                                    layout="prev, pager, next"
                                    :total="total">
                            </el-pagination>
                        </template>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('IoTDeviceManagement')" v-if="judge('Equipment_ViewIOTTab')" name="second">
                        <el-form ref="formselect" :model="formselect" label-width="60px" class="queryform_div">
                            <areaSelect :hasDeviceName="true" :level="level" :deviceType="deviceType" :formArea="formArea"
                                        :enablesys="'1'" @areaList="getAreaList"></areaSelect>
                            <el-form-item>
                                <el-button @click="selectByKeyword()" type="primary">{{ $t('Query') }}</el-button>
                                <el-button @click="reset('tab1')">{{ $t('Reset') }}</el-button>
                            </el-form-item>
                        </el-form>
                        <template>
                            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addNewIOT"
                                       v-if="judge('Equipment_CreateIOT')"
                                       style="margin-bottom:10px;">{{ $t('AddNewDevice') }}
                            </el-button>
                            <template v-if="judge('Equipment_DeleteIOT')">
                                <el-popconfirm placement="top"
                                               :confirmButtonText="$t('Delete')"
                                               :cancelButtonText="$t('Cancel')"
                                               icon="el-icon-info"
                                               iconColor="red"
                                               @onConfirm="batchDeleteEle"
                                               :title="$t('DeleteInformation')">>
                                    <el-button type="danger" slot="reference" style=" margin-left: 10px;">{{ $t('BatchDelete') }}
                                    </el-button>
                                </el-popconfirm>
                            </template>
                            <el-table ref="multipleTable"
                                      v-loading="loading"
                                      :data="tableData2"
                                      tooltip-effect="dark"
                                      @selection-change="handleSelectionChange"
                                      border
                                      stripe
                                      style="width:100%;min-height:200px;">
                                <el-table-column fixed="left"
                                                 type="selection"
                                                 width="50">
                                </el-table-column>
                                <el-table-column prop="index"
                                                 :label="$t('SN')"
                                                 width="50">
                                </el-table-column>
                                <el-table-column prop="deviceName"
                                                 :label="$t('Name')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="cityName"
                                                 :label="$t('City')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="factoryName"
                                                 :label="$t('Campus')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="buildingName"
                                                 :label="$t('Building')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="laboratoryName"
                                                 :label="$t('Lab')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="deviceName"
                                                 :label="$t('DeviceName')"
                                                 width="150">
                                </el-table-column>
                                <el-table-column prop="functionCode"
                                                 :label="$t('Functiontype')"
                                                 width="200">
                                </el-table-column>
                                <el-table-column prop="deviceTypeCode"
                                                 :label="$t('EquipmentType')"
                                                 width="150">
                                </el-table-column>
                                <el-table-column prop="mac"
                                                 :label="$t('MAC')"
                                                 width="150">
                                </el-table-column>
                                <el-table-column prop="ipAddress"
                                                 :label="$t('IPAddress')"
                                                 width="150">
                                </el-table-column>
                                <el-table-column prop="location"
                                                 :label="$t('InstallationPosition')"
                                                 width="100">
                                </el-table-column>

                                <!--                                <el-table-column prop="remark"-->
                                <!--                                                 label="备注"-->
                                <!--                                                 width="100">-->
                                <!--                                </el-table-column>-->

                                <el-table-column fixed="right"
                                                 :label="$t('Action')"
                                                 width="180">
                                    <template slot-scope="scope">
                                        <el-button v-if="judge('Equipment_UpdateIOT')" @click="editIOTInfo(scope.row)"
                                                   type="primary" size="small">{{ $t('Edit') }}
                                        </el-button>
                                        <template v-if="judge('Equipment_DeleteIOT')">
                                            <el-popconfirm placement="top"
                                                           :confirmButtonText="$t('Delete')"
                                                           :cancelButtonText="$t('Cancel')"
                                                           icon="el-icon-info"
                                                           iconColor="red"
                                                           @onConfirm="deleteEleById(scope.row.deviceRegionId)"
                                                           :title="$t('DeleteConfirm')">
                                                <el-button size="mini" type="danger" slot="reference"
                                                           style=" margin-left: 10px;">{{ $t('Delete') }}
                                                </el-button>
                                            </el-popconfirm>
                                        </template>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                    background
                                    @current-change="handleCurrentChange"
                                    layout="prev, pager, next"
                                    :total="total">
                            </el-pagination>
                        </template>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('OtherDeviceManagement')" v-if="judge('Equipment_ViewOtherTab')" name="third">
                        <el-form ref="formselect" :model="formselect" label-width="60px"
                                 class="queryform_div">
                            <areaSelect :hasDeviceName="true" :level="level" :deviceType="deviceType" :formArea="formArea"
                                        :enablesys="'1'" @areaList="getAreaList"></areaSelect>
                            <el-form-item>
                                <el-button @click="selectByKeyword()" type="primary">{{ $t('Query') }}</el-button>
                                <el-button @click="reset('tab1')">{{ $t('Reset') }}</el-button>
                            </el-form-item>
                        </el-form>
                        <template>
                            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addNewOther"
                                       v-if="judge('Equipment_CreateOther')"
                                       style="margin-bottom:10px;">{{ $t('AddNewDevice') }}
                            </el-button>
                            <template v-if="judge('Equipment_DeleteOther')">
                                <el-popconfirm placement="top"
                                               :confirmButtonText="$t('Delete')"
                                               :cancelButtonText="$t('Cancel')"
                                               icon="el-icon-info"
                                               iconColor="red"
                                               @onConfirm="batchDeleteEle"
                                               :title="$t('DeleteInformation')">>
                                    <el-button type="danger" slot="reference" style=" margin-left: 10px;">{{ $t('BatchDelete') }}
                                    </el-button>
                                </el-popconfirm>
                            </template>
                            <el-table ref="multipleTable"
                                      v-loading="loading"
                                      :data="tableData3"
                                      tooltip-effect="dark"
                                      @selection-change="handleSelectionChange"
                                      border
                                      stripe
                                      style="width:100%;min-height:200px;">
                                <el-table-column fixed="left"
                                                 type="selection"
                                                 width="50">
                                </el-table-column>
                                <el-table-column prop="index"
                                                 :label="$t('SN')"
                                                 width="50">
                                </el-table-column>
                                <el-table-column prop="deviceName"
                                                 :label="$t('DeviceName')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="cityName"
                                                 :label="$t('City')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="factoryName"
                                                 :label="$t('Campus')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="buildingName"
                                                 :label="$t('Building')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="laboratoryName"
                                                 :label="$t('Lab')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="departmentName"
                                                 :label="$t('Department')"
                                                 width="200">
                                </el-table-column>
                                <el-table-column prop="gatewayName"
                                                 :label="$t('Gateway')"
                                                 width="150">
                                </el-table-column>
                                <el-table-column prop="deviceTypeName"
                                                 :label="$t('EquipmentType')"
                                                 width="150">
                                </el-table-column>
                                <el-table-column prop="location"
                                                 :label="$t('InstallationPosition')"
                                                 width="100">
                                </el-table-column>
                                <!--                                <el-table-column prop="remark"-->
                                <!--                                                 label="备注"-->
                                <!--                                                 width="100">-->
                                <!--                                </el-table-column>-->
                                <el-table-column
                                                 :label="$t('Action')"
                                                 width="180">
                                    <template slot-scope="scope">
                                        <el-button v-if="judge('Equipment_UpdateOther')"
                                                   @click="editOtherInfo(scope.row)" type="primary" size="small">{{ $t('Edit') }}
                                        </el-button>
                                        <template v-if="judge('Equipment_DeleteOther')">
                                            <el-popconfirm placement="top"
                                                           :confirmButtonText="$t('Delete')"
                                                           :cancelButtonText="$t('Cancel')"
                                                           icon="el-icon-info"
                                                           iconColor="red"
                                                           @onConfirm="deleteEleById(scope.row.deviceRegionId)"
                                                           :title="$t('DeleteConfirm')">
                                                <el-button size="mini" type="danger" slot="reference"
                                                           style=" margin-left: 10px;">{{ $t('Delete') }}
                                                </el-button>
                                            </el-popconfirm>
                                        </template>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                    background
                                    @current-change="handleCurrentChange"
                                    layout="prev, pager, next"
                                    :total="total">
                            </el-pagination>
                        </template>
                    </el-tab-pane>
                </el-tabs>
            </el-main>
        </el-scrollbar>
        <el-dialog :title="(clickBtn==''? $t('addNew'): $t('Edit'))+ $t('electricityMeterEquipment')" v-if="dialogAddEquipment"
                   :visible.sync="dialogAddEquipment" width="80%" top="10vh">
            <el-form :inline="true" ref="Eqform" :model="Eqform" label-width="150px">
                <el-form-item :label="$t('City')">
                    <el-select :placeholder="$t('el.select.placeholder')" @change="getFac('add')" v-model="Eqform.cityId">
                        <el-option v-for="(item,index) in area" :key="'inx1'+index" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Campus')">
                    <el-select :placeholder="$t('el.select.placeholder')" @change="getBuild('add')" v-model="Eqform.factoryId">
                        <el-option v-for="(item,index) in facList" :key="'inx2'+index" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Building')" prop="buildingId" :rules="[{required:true,message: $t('selectBuilding')}]">
                    <el-select :placeholder="$t('el.select.placeholder')" @change="getLab('add')" v-model="Eqform.buildingId">
                        <el-option v-for="(item,index) in building" :key="'inx3'+index" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Lab')" style="width:100%">
                    <template>
                        <el-table :data="LabTable"
                                  ref="LabTable"
                                  border
                                  class="formSTable"
                                  style="width: 60vw;">
                            <el-table-column :label="$t('Action')"
                                             width="52px">
                                <template slot-scope="scope">
                                    <el-button icon="el-icon-delete"
                                               circle
                                               size="mini"
                                               type="danger"
                                               @click="delLabRow(scope.$index, scope.row)"></el-button>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('LabName')">
                                <template slot-scope="scope">
                                    <el-select :placeholder="$t('el.select.placeholder')" @change="getlaboratoryName(scope.row)"
                                               v-model="scope.row.laboratoryId" style="width:100%">
                                        <el-option value="00000000-0000-0000-0000-000000000000"
                                                   :label="$t('NonLaboratory')"></el-option>
                                        <el-option v-for="(item,index) in labList" :key="'inx4'+index"
                                                   :value="item.value"
                                                   :label="item.label"
                                                   v-if="item.value!='00000000-0000-0000-0000-000000000000'"
                                        ></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('Department1')">
                                <template slot-scope="scope">
                                    <el-select :placeholder="$t('el.select.placeholder')" v-model="scope.row.departmentId1">
                                        <el-option value="00000000-0000-0000-0000-000000000000" :label="$t('PleaseSelect')"></el-option>
                                        <el-option v-for="(item,index) in departMentList" :key="'a1'+index"
                                                   v-if="item.id!=scope.row.departmentId2&&item.id!=scope.row.departmentId3"
                                                   :value="item.id"
                                                   :label="item.departmentName"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('ElectricityConsumptionRatio')">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.percent1" :placeholder="$t('ElectricityConsumptionRatio')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('Department2')">
                                <template slot-scope="scope">
                                    <el-select :placeholder="$t('el.select.placeholder')" v-model="scope.row.departmentId2">
                                        <el-option value="00000000-0000-0000-0000-000000000000" :label="$t('PleaseSelect')"></el-option>
                                        <el-option v-for="(item,index) in departMentList" :key="'a2'+index"
                                                   v-if="item.id!=scope.row.departmentId1&&item.id!=scope.row.departmentId3"
                                                   :value="item.id"
                                                   :label="item.departmentName"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('ElectricityConsumptionRatio')">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.percent2" :placeholder="$t('ElectricityConsumptionRatio')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('Department3')">
                                <template slot-scope="scope">
                                    <el-select :placeholder="$t('el.select.placeholder')" v-model="scope.row.departmentId3">
                                        <el-option value="00000000-0000-0000-0000-000000000000" :label="$t('PleaseSelect')"></el-option>
                                        <el-option v-for="(item,index) in departMentList" :key="'a3'+index"
                                                   v-if="item.id!=scope.row.departmentId1&&item.id!=scope.row.departmentId2"
                                                   :value="item.id"
                                                   :label="item.departmentName"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('ElectricityConsumptionRatio')">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.percent3" :placeholder="$t('ElectricityConsumptionRatio')"></el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button class="el-icon-plus" @click.prevent="addLabRow()"></el-button>
                    </template>
                </el-form-item>
                <el-form-item :label="$t('DeviceName')" prop="deviceName" :rules="[{required:true,message: $t('PleaseEnterTheDeviceName')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.deviceName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('EquipmentCode')" prop="deviceCode" :rules="[{required:true,message: $t('PleaseEnterTheDeviceCode')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.deviceCode"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Functiontype')" prop="functionCode" :rules="[{required:true,message: $t('PleaseSelectTheFunctionType')}]">
                    <el-select style="width: 300px;" :placeholder="$t('el.select.placeholder')" v-model="Eqform.functionCode">
                        <el-option v-for="(item,index) in functionList" :key="'inx1'+index" :value="item.functionCode"
                                   :label="item.functionName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('CabinetNumber')" prop="cabinetCode" :rules="[{required:true,message: $t('PleaseEnterTheCabinetNumber')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.cabinetCode"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Brand')" prop="brand" :rules="[{required:true,message: $t('PleaseEnterTheBrand')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.brand"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Model')" prop="type" :rules="[{required:true,message: $t('PleaseEnterTheModelNumber')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.type"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Connectedtosystem')" prop="enableInSys" :rules="[{required:true,message: $t('connectToTheSystem')}]">
                    <el-select style="width: 300px;" :placeholder="$t('el.select.placeholder')" v-model="Eqform.enableInSys">
                        <el-option :value=true :label="$t('yes')"></el-option>
                        <el-option :value=false :label="$t('No')"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Ratedvoltage')" prop="ratedVoltage" :rules="[{required:true,message: $t('PleaseEnterTheRatedVoltage')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.ratedVoltage"><i slot="suffix" style="font-style:normal;margin-right: 10px;">V</i></el-input>
                </el-form-item>
                <el-form-item :label="$t('Ratedcurrent')" prop="ratedCurrent" :rules="[{required:true,message: $t('PleaseEnterTheRatedCurrent')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.ratedCurrent"><i slot="suffix" style="font-style:normal;margin-right: 10px;">A</i></el-input>
                </el-form-item>
                <el-form-item :label="$t('MaxInstantaneousPower')" prop="maxPower" :rules="[{required:true,message: $t('PleaseEnterMaximum')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.maxPower"><i slot="suffix" style="font-style:normal;margin-right: 10px;">W</i></el-input>
                </el-form-item>
                <el-form-item :label="$t('Accuracy')" prop="accuracy" :rules="[{required:true,message: $t('PleaseEnterAccuracy')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.accuracy"></el-input>
                </el-form-item>
                <el-form-item :label="$t('CurrentMultiplier')" prop="magnification" :rules="[{required:true,message: $t('PleaseEnterTheMagnification')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.magnification"></el-input>
                </el-form-item>
                <el-form-item :label="$t('byCurrentMultiplier')" prop="enableMultiply" :rules="[{required:true,message: $t('PleaseChooseWhether')}]">
                    <el-select style="width: 300px;" :placeholder="$t('el.select.placeholder')" v-model="Eqform.enableMultiply">
                        <el-option :value=true :label="$t('yes')"></el-option>
                        <el-option :value=false :label="$t('No')"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Position')" prop="location" :rules="[{required:true,message: $t('PleaseEnterTheLocation')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.location"></el-input>
                </el-form-item>
                <el-form-item :label="$t('SuperiorPowerSupply')" prop="power" :rules="[{required:true,message: $t('superiorPowerSupply')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.power"></el-input>
                </el-form-item>
                <el-form-item :label="$t('BaudRate')" prop="baudRate" :rules="[{required:true,message: $t('PleaseEnterTheBaudRate')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.baudRate"></el-input>
                </el-form-item>
                <el-form-item :label="$t('StartingBit')" prop="startBit" :rules="[{required:true,message: $t('PleaseEnterTheStartingPosition')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.startBit"></el-input>
                </el-form-item>
                <el-form-item  :label="$t('TerminationBit')" prop="stopBit" :rules="[{required:true,message: $t('TerminationBit')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.stopBit"></el-input>
                </el-form-item>
                <el-form-item :label="$t('CheckDigit')" prop="verifyBit" :rules="[{required:true,message: $t('PleaseEnterTheCheckDigit')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.verifyBit"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Gateway')" prop="GatewayId">
                    <el-select style="width: 300px;" v-model="Eqform.GatewayId">
                        <el-option :label="$t('PleaseSelect')" value=""></el-option>
                        <el-option v-for="(item,index) in tableData2" :key="'inx6'+index" :value="item.id"
                                   :label="item.deviceName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('IsItEnabled')" prop="status" :rules="[{required:true,message: $t('enableItOrNot')}]">
                    <el-select style="width: 300px;" :placeholder="$t('el.select.placeholder')" v-model="Eqform.status">
                        <el-option value="0" :label="$t('yes')"></el-option>
                        <el-option value="-1" :label="$t('No')"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item :label="$t('Grade')" prop="levelCode">
                    <el-select style="width: 300px;" v-model="Eqform.levelCode">
                        <el-option v-for="(item,index) in levelList" :key="'inx11'+index" :value="item.levelCode"
                                   :label="item.levelName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('ElectricityMeterAggregation')" prop="ecFlagCode">
                    <el-select style="width: 300px;" v-model="Eqform.ecFlagCode">
                        <el-option :label="$t('PleaseSelect')" value=""></el-option>
                        <el-option v-for="(item,index) in ecDataList" :key="'inx6'+index" :value="item.code"
                                   :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('BillNumber')">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.billNumber"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Remarks')">
                    <el-input style="width: 300px;" @input="change($event)" v-model="Eqform.remark"></el-input>
                </el-form-item>
                <el-form-item style="text-align: center;width: 100%;">
                    <el-button type="success" @click="onSubmit('Eqform')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogAddEquipment = false">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :title="(clickBtn==''?$t('addNew'): $t('Edit'))+ $t('IOTEquipment')" v-if="dialogAddIOT" :visible.sync="dialogAddIOT"
                   width="80%" top="10vh">
            <el-form :inline="true" ref="IOTform" :model="IOTform" label-width="150px">
                <el-form-item :label="$t('City')">
                    <el-select :placeholder="$t('el.select.placeholder')" @change="getFac('add1')" v-model="IOTform.cityId">
                        <el-option v-for="(item,index) in area" :key="'inx1'+index" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Campus')">
                    <el-select :placeholder="$t('el.select.placeholder')" @change="getBuild('add1')" v-model="IOTform.factoryId">
                        <el-option v-for="(item,index) in facList" :key="'inx2'+index" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Building')" prop="buildingId" :rules="[{required:true,message: $t('selectBuilding')}]">
                    <el-select :placeholder="$t('el.select.placeholder')" @change="getLab('add1')" v-model="IOTform.buildingId">
                        <el-option v-for="(item,index) in building" :key="'inx3'+index" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Lab')">
                    <el-select :placeholder="$t('el.select.placeholder')" multiple style="width: 300px;" v-model="IOTform.labInfos">
                        <el-option value="00000000-0000-0000-0000-000000000000" :label="$t('NonLaboratory')"></el-option>
                        <el-option v-for="(item,index) in labList" :key="'inx4'+index" :value="item.value"
                                   v-if="item.value!='00000000-0000-0000-0000-000000000000'"
                                   :label="item.label"></el-option>

                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('DeviceName')" prop="deviceName" :rules="[{required:true,message: $t('PleaseEnterTheDeviceName')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="IOTform.deviceName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('EquipmentCode')" prop="deviceCode" :rules="[{required:true,message: $t('PleaseEnterTheDeviceCode')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="IOTform.deviceCode"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Functiontype')" prop="functionCode" :rules="[{required:true,message: $t('PleaseEnterTheFunctionType')}]">
                    <!--                    <el-input style="width: 300px;" v-model="IOTform.functionCode"></el-input>-->
                    <el-select style="width: 300px;" :placeholder="$t('el.select.placeholder')" v-model="IOTform.functionCode">
                        <el-option v-for="(item,index) in functionList" :key="'inx1'+index" :value="item.functionCode"
                                   :label="item.functionName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('EquipmentType')" prop="deviceTypeCode" :rules="[{required:true,message: $t('PleaseEnterTheDeviceType')}]">
                    <el-select v-model="IOTform.deviceTypeCode">
                        <el-option v-for="(item,index) in IoTDeviceTypes" :label="item.deviceTypeName"
                                   :value="item.deviceTypeCode" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="MAC" prop="mac" :rules="[{required:true,message: '请输入MAC'}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="IOTform.mac"></el-input>
                </el-form-item>
                <el-form-item :label="$t('IPAddress')" prop="ipAddress" :rules="[{required:true,message: '请输入IP地址'}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="IOTform.ipAddress"></el-input>
                </el-form-item>
                <el-form-item :label="$t('InstallationPosition')" prop="location" :rules="[{required:true,message: $t('PleaseEnterInstallationLocation')}]">
                    <el-input style="width: 300px;" v-model="IOTform.location"></el-input>
                </el-form-item>
                <el-form-item :label="$t('IsItEnabled')" prop="status" :rules="[{required:true,message: $t('enableItOrNot')}]">
                    <el-select style="width: 300px;" :placeholder="$t('el.select.placeholder')" v-model="IOTform.status">
                        <el-option value="0" :label="$t('yes')"></el-option>
                        <el-option value="-1" :label="$t('No')"></el-option>
                    </el-select>
                </el-form-item>
                <!--                <el-form-item label="备注">-->
                <!--                    <el-input style="width: 300px;" v-model="IOTform.remark"></el-input>-->
                <!--                </el-form-item>-->
                <el-form-item style="text-align: center;width: 100%;">
                    <el-button type="success" @click="IOTonSubmit('IOTform')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogAddIOT = false">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :title="(clickBtn==''?$t('addNew'): $t('Edit'))+'其他设备'" v-if="dialogAddOther"
                   :visible.sync="dialogAddOther" width="80%" top="10vh">
            <el-form :inline="true" ref="otherform" :model="otherform" label-width="150px">
                <el-form-item :label="$t('City')">
                    <el-select :placeholder="$t('el.select.placeholder')" @change="getFac('add2')" v-model="otherform.cityId">
                        <el-option v-for="(item,index) in area" :key="'inx1'+index" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Campus')">
                    <el-select :placeholder="$t('el.select.placeholder')" @change="getBuild('add2')" v-model="otherform.factoryId">
                        <el-option v-for="(item,index) in facList" :key="'inx21'+index" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>


                <el-form-item :label="$t('Building')" prop="buildingId" :rules="[{required:true,message: $t('selectBuilding')}]">
                    <el-select :placeholder="$t('el.select.placeholder')" @change="getLab('add2')" v-model="otherform.buildingId">
                        <el-option v-for="(item,index) in building" :key="'inx3'+index" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Lab')">
                    <el-select :placeholder="$t('el.select.placeholder')" multiple style="width: 300px;" v-model="otherform.labInfos">
                        <el-option value="00000000-0000-0000-0000-000000000000" :label="$t('NonLaboratory')"></el-option>
                        <el-option v-for="(item,index) in labList" :key="'inx4'+index" :value="item.value"
                                   v-if="item.value!='00000000-0000-0000-0000-000000000000'"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('DeviceName')" prop="deviceName" :rules="[{required:true,message: $t('PleaseEnterTheDeviceName')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="otherform.deviceName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('EquipmentCode')" prop="deviceCode" :rules="[{required:true,message: $t('PleaseEnterTheDeviceCode')}]">
                    <el-input style="width: 300px;" @input="change($event)"  v-model="otherform.deviceCode"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Department')" prop="departmentCode" :rules="[{required:true,message: $t('PleaseEnterDepartment')}]">
                    <!--                    <el-input style="width: 300px;" v-model="otherform.departmentCode"></el-input>-->
                    <el-select style="width: 300px;" :placeholder="$t('el.select.placeholder')" v-model="otherform.departmentCode">
                        <el-option v-for="(item,index) in departMentList" :key="'inx1'+index"
                                   :value="item.departmentCode"
                                   :label="item.departmentName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Model')" prop="type" :rules="[{required:true,message: $t('PleaseEnterTheModelNumber')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="otherform.type"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Brand')" prop="brand" :rules="[{required:true,message: $t('PleaseEnterTheBrand')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="otherform.brand"></el-input>
                </el-form-item>
                <el-form-item :label="$t('EquipmentType')" prop="deviceTypeCode" :rules="[{required:true,message: $t('PleaseEnterTheDeviceType')}]">
                    <el-select :placeholder="$t('el.select.placeholder')" style="width: 300px;" v-model="otherform.deviceTypeCode">
                        <el-option v-for="(item,index) in OtherDeviceTypes" :label="item.deviceTypeName"
                                   :value="item.deviceTypeCode" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Connectedtosystem')" prop="enableInSys" :rules="[{required:true,message: $t('connectToTheSystem')}]">
                    <el-select style="width: 300px;" :placeholder="$t('el.select.placeholder')" v-model="otherform.enableInSys">
                        <el-option :value=true :label="$t('yes')"></el-option>
                        <el-option :value=false :label="$t('No')"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('IsItEnabled')" prop="status" :rules="[{required:true,message: $t('enableItOrNot')}]">
                    <el-select style="width: 300px;" :placeholder="$t('el.select.placeholder')" v-model="otherform.status">
                        <el-option value='0' :label="$t('yes')"></el-option>
                        <el-option value='-1' :label="$t('No')"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('IsItOutdoor')" prop="isOutdoor" :rules="[{required:true,message: $t('itIsOutdoorOrNot')}]">
                    <el-select style="width: 300px;" :placeholder="$t('el.select.placeholder')" v-model="otherform.isOutdoor">
                        <el-option :value=true :label="$t('yes')"></el-option>
                        <el-option :value=false :label="$t('No')"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Accuracy')" prop="accuracy" :rules="[{required:true,message: $t('PleaseEnterAccuracy')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="otherform.accuracy"></el-input>
                </el-form-item>
                <el-form-item :label="$t('InstallationPosition')" prop="location" :rules="[{required:true,message: $t('PleaseEnterInstallationLocation')}]">
                    <el-input style="width: 300px;" @input="change($event)" v-model="otherform.location"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Gateway')" prop="GatewayId">
                    <el-select style="width: 300px;" v-model="otherform.GatewayId">
                        <el-option :label="$t('PleaseSelect')" value=""></el-option>
                        <el-option v-for="(item,index) in tableDataGetaway" :key="'inx7'+index" :value="item.id"
                                   :label="item.deviceName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('BillNumber')">
                    <el-input style="width: 300px;" @input="change($event)" v-model="otherform.billNumber"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Remarks')">
                    <el-input style="width: 300px;" @input="change($event)" v-model="otherform.remark"></el-input>
                </el-form-item>
                <el-form-item style="text-align: center;width: 100%;">
                    <el-button type="success" @click="otheronSubmit('otherform')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogAddOther = false">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {fancha, getDeviceNameByid} from '../../utils/util'
    import areaSelect from '../../components/content/maintabber/areaSelect'
    import {
        GetAllElectricInfo,
        GetMyRegionChainList,
        GetAllIoTDevice,
        GetAllFunction,
        GetAllDepartment,
        updateIoTDevice,
        BatchDeleteElectric,
        BatchDeleteIoTDevice,
        getIoTDeviceTypes,
        updateElectric,
        getCityAll,
        DeleteElectric,
        createElectric,
        createIoTDevice,
        GetLabByBuildingId,
        getFactoryAlls,
        GetAllBuilding,
        getLabAll,
        GetByCityId,
        GetAllOtherDevice,
        createOtherDevice,
        updateOtherDevice,
        DeleteOtherDevice,
        BatchDeleteOtherDevice,
        getOtherDeviceTypes,
        DeleteIoTDevice,
        GetByFactoryId,
        getLevel,
        GetAllEcFlagConfig
    } from '../../api/api';
    import {judgePermission} from '../../utils/util'

    export default {
        name: "Equipment_information_management",
        components: {
            areaSelect,
        },
        data() {
            return {
                level: 4,
                deviceType: "",
                formArea: {cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: ""},

                activeName: "first",
                OtherDeviceTypes: '',
                area: JSON.parse(sessionStorage.getItem("area")),
                facList: [],
                building: [],
                labList: [],
                deviveList: [],
                levelList: [],

                formselect: {
                    DeviceName: "",
                    cityId: "",
                    factoryId: "",
                    buildingId: "",
                    LabId: "",
                    maxResultCount: 10,
                    deviceTypeCode: '',
                },
                noLab: '',
                LabTable: [
                    {
                        laboratoryId: "",
                        elecConsumPercent: '0',
                        departmentId1: '',
                        percent1: '',
                        departmentId2: '',
                        percent2: '',
                        departmentId3: '',
                        percent3: '',
                    }
                ],
                IOTform: {
                    countryId: "",
                    deviceCode: "",
                    cityId: "",
                    factoryName: "",
                    buildingId: "",
                    LabInfos: "",
                    status: "",
                    deviceName: "",
                    functionCode: "",
                    deviceTypeCode: "",
                    mac: "",
                    ipAddress: "",
                    location: "",
                    remark: "",
                },
                otherform: {
                    id: "",
                    deviceCode: "",
                    countryId: '',
                    cityId: '',
                    factoryName: '',
                    buildingId: '',
                    labInfos: [],
                    deviceName: '',
                    departmentCode: '',
                    status: '',
                    type: '',
                    brand: '',
                    deviceTypeCode: '',
                    enableInSys: '',
                    accuracy: '',
                    location: '',
                    billNumber: '',
                    remark: '',
                    isOutdoor:''
                },
                dialogAddEquipment: false,
                dialogAddIOT: false,
                dialogAddOther: false,
                dialogEditEquipment: false,
                currentPage: 0,
                total: 0,
                tableData1: [],
                tableData2: [],
                tableDataGetaway: [],
                tableData3: [],
                multipleSelection: [],
                Eqform: {
                    countryId: '',
                    deviceCode: '',
                    cityId: '',
                    factoryName: '',
                    buildingId: '',
                    labInfos: [],
                    lab: '',
                    status: '',
                    deviceName: '',
                    functionCode: '',
                    // departmentCode: '',
                    cabinetCode: '',
                    brand: '',
                    type: '',
                    enableInSys: '',
                    ratedVoltage: '',
                    ratedCurrent: '',
                    maxPower:'',
                    accuracy: '',
                    magnification: '',
                    enableMultiply:'',
                    location: '',
                    power: '',
                    baudRate: '',
                    startBit: '',
                    stopBit: '',
                    verifyBit: '',
                    levelCode: '',
                    billNumber: '',
                    ecFlagCode:'',
                    remark: '',
                },
                country: [{
                    value: '00000000-0000-0000-0000-000000000000',
                    label: '中国'
                }],
                city: [],
                pack: [],
                buiilding: [],
                lab: [],
                clickBtn: "",
                IoTDeviceTypes: [],
                loading: false,
                functionList: [],
                departMentList: [],
                ecDataList:[]
            }
        },
        mounted() {
            if (this.judge('Equipment_ViewElectricTab')) {
                this.electricInfo()       //电表设备信息管理
            }
            if (this.judge('Equipment_ViewIOTTab')) {
                this.getTable2()
            }
            if (this.judge('Equipment_ViewOtherTab')) {
                this.getOtherTypes()        //获取其他设备类型
            }
            this.getFunction()          //获取功能类型
            this.getDepartment()          //获取功能类型
            this.getLevelList()
            this.getIoTTypes()   //获取IOT设备类型
            this.getEcFlag() //获取电表聚合标识配置
        },
        methods: {
            getAreaList(e) {
                this.formselect = {...this.formselect, ...e.Valueform}
                if(this.formselect.DeviceName){
                    this.selectByKeyword()
                }
            },

            getLevelList() {
                var that = this
                getLevel().then(res => {
                    if (res.success) {
                        that.levelList = res.result
                    }
                })
            },
            judge(e) {
                return judgePermission(e)
            },
            getFunction() {
                var that = this
                GetAllFunction().then(res => {
                    if (res.success) {
                        that.functionList = res.result.items
                    }
                })
            },
            getDepartment() {
                var that = this
                GetAllDepartment().then(res => {
                    if (res.success) {
                        that.departMentList = res.result.items
                    }
                })
            },
            getEcFlag(){
                 
                var that = this
                GetAllEcFlagConfig().then(res => {
                    if (res.success) {
                        that.ecDataList = res.result.items
                    }
                })
            },
            getFac(e) {
                 
                var a = '',
                    id = e == 'add' ? this.Eqform.cityId : (e == 'add1' ? this.IOTform.cityId : (e == 'add2' ? this.otherform.cityId : this.formselect.cityId))
                this.area.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.facList = this.area[a].children
                this.building = []
                this.labList = []
                this.deviveList = []
                this.formselect = {...this.formselect, ...{factoryId: "", buildingId: "", LabId: "", deviceId: ""}}
                this.Eqform = {...this.Eqform, ...{factoryId: "", buildingId: "", LabId: "", deviceId: ""}}
                this.IOTform = {...this.IOTform, ...{factoryId: "", buildingId: "", LabId: "", deviceId: ""}}
                this.otherform = {...this.otherform, ...{factoryId: "", buildingId: "", LabId: "", deviceId: ""}}

                this.tableDataGetaway  = this.tableData2.filter((item, i) => {
                    return item.cityId ==  this.otherform.cityId;
                })
            },
            getBuild(e) {
                 
                var a = '',
                    id = e == 'add' ? this.Eqform.factoryId : (e == 'add1' ? this.IOTform.factoryId : (e == 'add2' ? this.otherform.factoryId : this.formselect.factoryId))
                this.facList.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.building = this.facList[a].children
                this.labList = []
                this.deviveList = []
                this.formselect = {...this.formselect, ...{buildingId: "", LabId: "", deviceId: ""}}
                this.Eqform = {...this.Eqform, ...{buildingId: "", LabId: "", deviceId: ""}}
                this.IOTform = {...this.IOTform, ...{buildingId: "", LabId: "", deviceId: ""}}
                this.otherform = {...this.otherform, ...{buildingId: "", LabId: "", deviceId: ""}}
            },
            getLab(e) {
                var a = '',
                    id = e == 'add' ? this.Eqform.buildingId : (e == 'add1' ? this.IOTform.buildingId : (e == 'add2' ? this.otherform.buildingId : this.formselect.buildingId))
                this.building.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.labList = this.building[a].children
                this.deviveList = []
                this.formselect = {...this.formselect, ...{LabId: "", deviceId: ""}}
                this.Eqform = {...this.Eqform, ...{LabId: "", deviceId: ""}}
                this.IOTform = {...this.IOTform, ...{LabId: "", deviceId: ""}}
                this.otherform = {...this.otherform, ...{LabId: "", deviceId: ""}}
                this.LabTable = [
                    {
                        laboratoryId: '',
                        elecConsumPercent: '0',
                        departmentId1: '00000000-0000-0000-0000-000000000000',
                        percent1: '100',
                        departmentId2: '00000000-0000-0000-0000-000000000000',
                        percent2: '0',
                        departmentId3: '00000000-0000-0000-0000-000000000000',
                        percent3: '0',
                    }
                ]
            },
            getDevide(e) {
                var a = '',
                    id = e == 'add' ? this.Eqform.LabId : (e == 'add1' ? this.IOTform.LabId : (e == 'add2' ? this.otherform.LabId : this.formselect.LabId))
                this.labList.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.deviveList = this.labList[a].children
                this.formselect = {...this.formselect, ...{deviceId: ""}}
                this.Eqform = {...this.Eqform, ...{deviceId: ""}}
                this.IOTform = {...this.IOTform, ...{deviceId: ""}}
                this.otherform = {...this.otherform, ...{deviceId: ""}}
            },
            change(e) {
                 
                this.$forceUpdate()
                this.$watch('Eqform.ratedVoltage',this.ratedVoltageChange)
                this.$watch('Eqform.ratedCurrent',this.ratedVoltageChange1)
            },
            delLabRow(index, row) {
                this.LabTable.splice(index, 1);
            },
            addLabRow() {
                var list = {
                    laboratoryId: '',
                    elecConsumPercent: '0',
                    departmentId1: '00000000-0000-0000-0000-000000000000',
                    percent1: '100',
                    departmentId2: '00000000-0000-0000-0000-000000000000',
                    percent2: '0',
                    departmentId3: '00000000-0000-0000-0000-000000000000',
                    percent3: '0',
                };
                this.LabTable.unshift(list)
                this.LabrowNum += 1;
            },
            getlaboratoryName(value) {
                this.lab.map(item => {
                    if (value.laboratoryId == item.id) {
                        value.laboratoryName = item.labName
                    }
                })
            },
            //筛选
            selectByKeyword(e) {
                this.currentPage = 0
                this.electricInfo()
            },
            //获取IOT设备类型
            getIoTTypes() {
                var that = this
                getIoTDeviceTypes().then(res => {

                    if (res.success) {
                        that.IoTDeviceTypes = res.result
                    }
                })
            },
            //其他设备类型列表
            getOtherTypes() {
                var that = this
                getOtherDeviceTypes().then(res => {

                    if (res.success) {
                        that.OtherDeviceTypes = res.result
                    }
                })
            },
            //电表、IOT、其他设备批量删除
            batchDeleteEle() {
                var data = this.multipleSelection, that = this
                if (data.length == 0) {
                    this.$message.warning("请勾选至少一项")
                    return false;
                }
                var arr = []
                data.map(item => {
                    arr.push(item.deviceRegionId)
                })
                if (this.activeName == 'first') {
                    BatchDeleteElectric(arr).then(res => {
                        if (res.success) {
                            that.$message.success(this.$t('BatchDeletionSuccessful'))
                            that.electricInfo()
                        }
                    })
                } else if (this.activeName == 'second') {
                    BatchDeleteIoTDevice(arr).then(res => {
                        if (res.success) {
                            that.$message.success(this.$t('BatchDeletionSuccessful'))
                            that.electricInfo()
                        }
                    })
                } else {
                    BatchDeleteOtherDevice(arr).then(res => {
                        if (res.success) {
                            that.$message.success(this.$t('BatchDeletionSuccessful'))
                            that.electricInfo()
                        }
                    })
                }
            },
            //导航栏切换
            handleClick(tab, event) {
                this.currentPage = 0
                this.multipleSelection = []
                this.reset('tab')
            },
            //电表新增
            addNew() {
                this.reset()
                this.dialogAddEquipment = true
                this.clickBtn = ''
                this.LabTable = []
                this.facList = []
                this.building = []
                this.labList = []
            },
            //IOT新增
            addNewIOT() {
                this.reset()
                this.dialogAddIOT = true
                this.clickBtn = ''
                this.facList = []
                this.building = []
                this.labList = []
            },
            //其他新增
            addNewOther() {
                this.reset()
                this.dialogAddOther = true
                this.clickBtn = ''
                this.facList = []
                this.building = []
                this.labList = []
            },
            //分页数据
            handleCurrentChange(val) {
                 
                this.currentPage = JSON.parse(val - 1) * 10;
                this.electricInfo()
            },
            //iot修改
            editIOTInfo(e) {
                this.dialogAddIOT = true
                this.clickBtn = 'edit'
                this.IOTform = JSON.parse(JSON.stringify(e))


                this.$set(this.IOTform, "status", e.status + "")
                var arr = []
                if (e.labInfos) {
                    e.labInfos.map(i => {
                        arr.push(i.laboratoryId)
                    })
                }
                this.IOTform.labInfos = arr
                var data = fancha(e.id)
                // console.log(data)
                for (var i in data) {
                    switch (i) {
                        case "0":
                            this.IOTform.cityId = this.area[data[i]].value
                            this.facList = this.area[data[i]].children
                            break;
                        case "1":
                            this.IOTform.factoryId = this.facList[data[i]].value
                            this.building = this.facList[data[i]].children
                            break;
                        case "2":
                            this.IOTform.buildingId = this.building[data[i]].value
                            this.labList = this.building[data[i]].children
                            break;editOtherInfo
                        case "3":
                            this.IOTform.LabId = this.labList[data[i]].value || "00000000-0000-0000-0000-000000000000"
                            this.deviveList = this.labList[data[i]].children
                            break;
                        case "4":
                            this.IOTform.deviceId = this.deviveList[data[i]].value
                            break;
                    }
                }
            },
            //其他修改
            editOtherInfo(e) {
                 
                this.dialogAddOther = true
                this.clickBtn = 'edit'
                // e.enableInSys = e.enableInSys ? "0" : "1"
                this.otherform = JSON.parse(JSON.stringify(e))
                this.$set(this.otherform, "status", e.status + "")
                var arr = []
                if (e.labInfos) {
                    e.labInfos.map(i => {
                        arr.push(i.laboratoryId)
                    })
                }
                this.otherform.labInfos = arr
                if (e.gatewayId == "00000000-0000-0000-0000-000000000000") {
                    this.$set(this.otherform, "GatewayId", '')
                } else {
                    this.$set(this.otherform, "GatewayId", e.gatewayId)
                }

                this.$set(this.otherform, "departmentCode", e.departmentCode)

                var data = fancha(e.id)
                for (var i in data) {
                    switch (i) {
                        case "0":
                            this.otherform.cityId = this.area[data[i]].value
                            this.facList = this.area[data[i]].children
                            break;
                        case "1":
                            this.otherform.factoryId = this.facList[data[i]].value
                            this.building = this.facList[data[i]].children
                            break;
                        case "2":
                            this.otherform.buildingId = this.building[data[i]].value
                            this.labList = this.building[data[i]].children
                            break;
                        case "3":
                            this.otherform.LabId = this.labList[data[i]].value
                            this.deviveList = this.labList[data[i]].children
                            break;
                        case "4":
                            this.otherform.deviceId = this.deviveList[data[i]].value
                            break;
                    }
                }
                // this.getFac('add2');
                  this.tableDataGetaway  = this.tableData2.filter((item, i) => {
                    return item.cityId ==  this.otherform.cityId;
                })
            },
            //电表修改
            editInfo(e) {
                 
                this.dialogAddEquipment = true
                // e.enableInSys = e.enableInSys ? "0" : "1"
                this.Eqform.id = e.id
                this.Eqform.countryId = e.countryId
                this.Eqform.deviceCode = e.deviceCode
                this.Eqform.cityId = e.cityId
                this.Eqform.factoryName = e.factoryName
                this.Eqform.buildingId = e.buildingId
                this.Eqform.status = e.status + ''

                this.Eqform.lab = e.lab
                this.Eqform.deviceName = e.deviceName
                this.Eqform.functionCode = e.functionCode
                // this.Eqform.departmentCode = e.departmentCode
                this.Eqform.cabinetCode = e.cabinetCode
                this.Eqform.billNumber = e.billNumber
                this.Eqform.brand = e.brand
                this.Eqform.type = e.type
                // this.Eqform.enableInSys = e.enableInSys ? "0" : "1"
                this.Eqform.ratedVoltage = e.ratedVoltage
                this.Eqform.ratedCurrent = e.ratedCurrent
                this.Eqform.maxPower = e.maxPower
                this.Eqform.accuracy = e.accuracy
                this.Eqform.magnification = e.magnification
                this.Eqform.enableMultiply = e.enableMultiply
                this.Eqform.location = e.location
                this.Eqform.power = e.power
                this.Eqform.baudRate = e.baudRate
                this.Eqform.startBit = e.startBit
                this.Eqform.stopBit = e.stopBit
                this.Eqform.verifyBit = e.verifyBit
                this.Eqform.remark = e.remark
                // this.Eqform.GatewayId = e.GatewayId
                if (e.gatewayId == "00000000-0000-0000-0000-000000000000") {
                    this.$set(this.Eqform, "GatewayId", '')
                } else {
                    this.$set(this.Eqform, "GatewayId", e.gatewayId)
                }
                this.$set(this.Eqform, "enableInSys", e.enableInSys)
                this.$set(this.Eqform, "ecFlagCode", e.ecFlagCode)
                this.clickBtn = 'edit'
                // 
                this.Eqform.levelCode = e.levelCode
                var data = fancha(e.deviceID)
                // console.log(data)
                for (var i in data) {
                    switch (i) {
                        case "0":
                            this.Eqform.cityId = this.area[data[i]].value
                            this.facList = this.area[data[i]].children
                            break;
                        case "1":
                            this.Eqform.factoryId = this.facList[data[i]].value
                            this.building = this.facList[data[i]].children
                            break;
                        case "2":
                            this.Eqform.buildingId = this.building[data[i]].value
                            this.labList = this.building[data[i]].children
                            break;
                        case "3":
                            this.Eqform.LabId = this.labList[data[i]].value
                            this.deviveList = this.labList[data[i]].children
                            break;
                        case "4":
                            this.Eqform.deviceId = this.deviveList[data[i]].value
                            break;
                    }
                }
                if (e.labInfos) {
                    this.LabTable = JSON.parse(JSON.stringify(e.labInfos))
                    var arr = []
                    this.LabTable.map(item => {
                        var obj = {}
                        obj.laboratoryId = item.laboratoryId
                        obj.departmentId1 = item.departmentId1
                        obj.percent1 = item.percent1
                        obj.departmentId2 = item.departmentId2
                        obj.percent2 = item.percent2
                        obj.departmentId3 = item.departmentId3
                        obj.percent3 = item.percent3
                        arr.push(obj)
                    })
                    this.$set(this.Eqform, 'labInfos', arr)
                    this.$set(this, 'LabTable', arr)
                }
                // console.log(this.Eqform.labInfos)
                // console.log(e)
            },
            getTable2() {
                var that = this, data = {
                    currentPage: this.currentPage,
                }
                data = Object.assign(data, this.formselect)
                data.maxResultCount = 100
                GetAllIoTDevice(data).then(res => {
                    if (res.success) {
                        that.tableData2 = res.result.items
                    }
                })
            },
            reset(e) {

                //this.formArea = {DeviceName: "",cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: ""}
                //this.formselect = {deviceId: "", deviceCode: ""}

                this.Eqform = {
                    countryId: '',
                    cityId: '',
                    factoryName: '',
                    buildingId: '',
                    labInfos: [],
                    lab: '',
                    deviceName: '',
                    functionCode: '',
                    // departmentCode: '',
                    cabinetCode: '',
                    brand: '',
                    type: '',
                    enableInSys: '',
                    ratedVoltage: '',
                    ratedCurrent: '',
                    maxPower:'',
                    accuracy: '',
                    magnification: '',
                    enableMultiply:'',
                    location: '',
                    power: '',
                    baudRate: '',
                    startBit: '',
                    stopBit: '',
                    verifyBit: '',
                    billNumber:'',
                    remark: '',
                }
                this.IOTform = {
                    countryId: "",
                    cityId: "",
                    factoryName: "",
                    labInfos: [],
                    buildingId: "",
                    LabInfos: "",
                    deviceName: "",
                    functionCode: "",
                    deviceTypeCode: "",
                    mac: "",
                    ipAddress: "",
                    location: "",
                    remark: "",
                }
                this.otherform = {
                    id: "",
                    countryId: '',
                    cityId: '',
                    factoryName: '',
                    buildingId: '',
                    labInfos: [],
                    deviceName: '',
                    departmentCode: '',
                    type: '',
                    brand: '',
                    deviceTypeCode: '',
                    enableInSys: '',
                    accuracy: '',
                    location: '',
                    billNumber:'',
                    remark: '',
                }

                if (e == 'tab1' || e == 'tab') {
                    this.formselect = {
                        DeviceName: "",
                        cityId: "",
                        factoryId: "",
                        buildingId: "",
                        LabId: ""
                    }
                     this.formArea = {DeviceName: "",cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: ""}
                    this.electricInfo()
                }
                // if (e == 'tab') {
                //     this.electricInfo()
                // }
            },
            //获取表格数据
            electricInfo() {
                 
                this.loading = true
                var that = this, data = {
                    currentPage: this.currentPage,
                    SkipCount: this.currentPage,
                }
                data = Object.assign(data, this.formselect)
                if (this.activeName == 'first') {
                    GetAllElectricInfo(data).then(res => {
                        if (res.success) {
                            that.total = res.result.totalCount
                            that.tableData1 = res.result.items
                            that.tableData1.forEach((item, index) => {
                                item.index = index + 1
                            })
                        }
                        that.loading = false
                    })
                } else if (this.activeName == 'second') {
                    data.maxResultCount = 10
                    GetAllIoTDevice(data).then(res => {
                        if (res.success) {
                            that.total = res.result.totalCount
                            that.tableData2 = res.result.items
                            that.tableData2.map((item, index) => {
                                item.index = index + 1
                            })
                        }
                        that.loading = false
                    })
                } else {
                     
                    GetAllOtherDevice(data).then(res => {
                        if (res.success) {
                            that.total = res.result.totalCount
                            that.tableData3 = res.result.items
                            that.tableData3.map((item, index) => {
                                item.index = index + 1
                            })
                        }
                        that.loading = false
                    })
                }
                this.RegionMyService()
            },
            //更新地域
            RegionMyService() {
                var that = this;
                GetMyRegionChainList().then((res) => {
                    // console.log(res);
                    if (res.success) {
                        var str = JSON.stringify(res.result);
                        // console.log(str)
                        str = str.replace(/cityList/g, "children");
                        str = str.replace(/factoryList/g, "children");
                        str = str.replace(/buildingList/g, "children");
                        str = str.replace(/labList/g, "children");
                        str = str.replace(/deviceList/g, "children");
                        str = str.replace(/id/g, "value");
                        str = str.replace(/name/g, "label");
                        this.data = JSON.parse(str);
                        that.getCurrentPart(this.data);
                        this.data = JSON.stringify(this.data);
                        sessionStorage.setItem("deviceList", this.data);
                        sessionStorage.setItem("area", JSON.stringify(JSON.parse(this.data)[0].children));
                    } else {
                        that.$message.error(this.$t('InterfaceRequestError'));
                    }
                });
            },
            getCurrentPart(items) {
                items.map((i) => {
                    if (i.children) {
                        this.getCurrentPart(i.children);
                    } else {
                        delete i.children;
                    }
                });
            },
            deleteEleById(id) {
                var data = {id}, that = this
                if (this.activeName == 'first') {
                    DeleteElectric(data).then(res => {
                        if (res.success) {
                            that.$message.success(this.$t('deleteSuccessful'))
                            that.electricInfo()
                        }
                    })
                } else if (this.activeName == 'second') {
                    DeleteIoTDevice(data).then(res => {
                        if (res.success) {
                            that.$message.success(this.$t('deleteSuccessful'))
                            that.electricInfo()
                        }
                    })
                } else {
                    DeleteOtherDevice(data).then(res => {
                        if (res.success) {
                            that.$message.success(this.$t('deleteSuccessful'))
                            that.electricInfo()
                        }
                    })
                }

            },
            IOTonSubmit(IOTform) {
                var that = this
                this.$refs[IOTform].validate((valid) => {
                    if (valid) {
                        var data = this.IOTform
                        var arr = []
                        data.labInfos.map(item => {
                            var obj = {}
                            obj.laboratoryName = getDeviceNameByid(item, JSON.parse(sessionStorage.getItem("area"))).label
                            obj.laboratoryId = item
                            if (item != '00000000-0000-0000-0000-000000000000') {
                                arr.push(obj)
                            }
                        })
                        data.labInfos = arr
                        delete data.factoryName
                        delete data.deviceId
                        delete data.countryId
                        delete data.LabId
                        delete data.LabInfos
                        if (this.clickBtn == '') {
                            delete data.id
                            createIoTDevice(data).then(res => {
                              
                                if (res.success) {
                                    that.$message.success(this.$t('NewSuccessfullyAdded'))
                                    that.dialogAddIOT = false
                                    that.electricInfo()
                                    that.reset()
                                } else {
                                    that.$message.error(res.error.message)
                                }
                            })
                        } else {
                            updateIoTDevice(data).then(res => {
                                if (res.success) {
                                    that.$message.success(this.$t('Update'))
                                    that.dialogAddIOT = false
                                    that.electricInfo()
                                    that.reset()
                                } else {
                                    that.$message.error(res.error.message)
                                }
                            })
                        }

                    } else {
                        return false;
                    }
                })
            },
            onSubmit(Eqform) {

                var that = this
                this.$refs[Eqform].validate((valid) => {
                    if (valid) {
                        // 
                        var data = JSON.parse(JSON.stringify(this.Eqform))
                        var d = "00000000-0000-0000-0000-000000000000"
                        // data.enableInSys = data.enableInSys == "0" ? true : false
                        data.labInfos = JSON.parse(JSON.stringify(this.LabTable))
                        data.labInfos.map(item => {
                            if (item.laboratoryId == '') {
                                item.laboratoryId = d
                            }
                        })
                        delete data.buiilding
                        delete data.lab
                        delete data.pack
                        delete data.countryId
                        delete data.cityId
                        if (this.LabTable.length === 0) {
                            this.$message.warning(this.$t('PleaseSelectAtLeastOneDepartment'))
                            return;
                        } else {

                            this.LabTable.map(item => {
                                if ((!item.departmentId1 && !item.departmentId2 && !item.departmentId3) || (item.departmentId1 == d && item.departmentId2 == d && item.departmentId3 == d)) {
                                    this.$message.warning(this.$t('departmentForEachLaboratory'))
                                    return;
                                }
                            })
                        }
                        // return;
                        if (this.clickBtn == 'edit') {
                             
                            updateElectric(data).then(res => {
                                if (res.success) {
                                    that.dialogAddEquipment = false
                                    that.$message.success(this.$t('Update'))
                                    this.electricInfo()
                                    that.reset()
                                } else {
                                    that.dialogAddEquipment = true
                                    that.$message.error(res.error.message)
                                }
                            })
                        } else {

                            // return;
                            createElectric(data).then(res => {
                        
                                if (res.success) {
                                    that.dialogAddEquipment = false
                                    that.$message.success(this.$t('NewSuccessfullyCreated'))
                                     this.electricInfo()
                                    that.reset()

                                } else {
                                    that.dialogAddEquipment = true
                                    that.$message.error(res.error.message)
                                }
                            })
                        }
                    } else {
                        console.log('error submit!!');
                        //return false;
                    }
                })
            },
            otheronSubmit(otherform) {
                
                var that = this
                this.$refs[otherform].validate((valid) => {
                    if (valid) {
                        var data = this.otherform

                        // data.labInfos = this.otherform.laboratoryIds
                        var arr = []
                        data.labInfos.map(item => {
                            var obj = {}
                            obj.laboratoryName = getDeviceNameByid(item, JSON.parse(sessionStorage.getItem("area"))).label
                            obj.laboratoryId = item
                            if (item != '00000000-0000-0000-0000-000000000000') {
                                arr.push(obj)
                            }
                        })
                        data.labInfos = arr
                        // data.enableInSys = data.enableInSys == '0' ? true : false
                        if (this.clickBtn == '') {
                            delete data.id
                            delete data.countryId
                            delete data.cityId
                            delete data.factoryName
                            createOtherDevice(data).then(res => {
                                if (res.success) {
                                    that.$message.success(this.$t('NewSuccessfullyAdded'))
                                    that.dialogAddOther = false
                                     that.electricInfo()
                                    that.reset()
                                } else {
                                    that.$message.error(res.error.message)
                                }
                            })
                        } else {
                            delete data.countryId
                            delete data.cityId
                            delete data.factoryName
                            updateOtherDevice(data).then(res => {
                                if (res.success) {
                                    that.$message.success(this.$t('Update'))
                                    that.dialogAddOther = false
                                     that.electricInfo()
                                    that.reset()
                                } else {
                                    that.$message.error(res.error.message)
                                }
                            })
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            ratedVoltageChange(){
                if(this.Eqform.ratedVoltage&& this.Eqform.ratedCurrent){
                    this.Eqform.maxPower = parseFloat(this.Eqform.ratedVoltage)*parseFloat(this.Eqform.ratedCurrent)*3;
                }else{
                    this.Eqform.maxPower =0;
                }
            },

             ratedVoltageChange1(){
                if(this.Eqform.ratedVoltage&& this.Eqform.ratedCurrent){
                    this.Eqform.maxPower = parseFloat(this.Eqform.ratedVoltage)*parseFloat(this.Eqform.ratedCurrent)*3;
                }else{
                    this.Eqform.maxPower =0;
                }
            },


        },
        computed: mapState({
            isCollapse: state => state.isCollapse
        }),
    }
</script>

<style scoped>
    #formPer .el-form-item__content {
        line-height: 35px;
        border-left: 1px solid #EBEEF5;
        padding-left: 10px;
    }

    #formPer > .el-form-item {
        margin-bottom: 0px;
        border-bottom: 1px solid #EBEEF5;
    }

    #formPer .noborder .el-form-item__content {
        border: 0;
    }

    #formPer .noborder {
        border: 0;
        margin-top: 20px;
    }
</style>
